import styled from 'styled-components'
import colors from './../../styles/colors'

import coins from './../../../img/input-coins.png'

export const StyledDecorativeInput = styled.div`
  display: inline-block;
  color: ${colors.red};

  position: relative;

  max-width: 100%;

  padding: 0 70px;
  margin: 1rem 0;

  ::before,
  ::after {
    content: '';
    position: absolute;
    bottom: 0;

    width: 60px;
    height: 44px;

    background-image: url(${coins});
    background-size: contain;
    background-repeat: no-repeat;
  }

  ::before {
    left: 0;
  }

  ::after {
    right: 0;
    transform: scaleX(-1);
  }
`

export const StyledInput = styled.input`
  background: none;
  outline: none;
  border: none;
  border-bottom: 3px solid ${colors.red};

  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 2px;

  width: 100%;
  max-width: 300px;
  padding: 0.5rem;

  color: ${colors.red};

  ::placeholder {
    color: ${colors.red};
    opacity: 0.5;
  }
`
